// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__188Xs","notes":"Notes_notes__2nUyf"};